import useFetch from 'app/hooks/useFetch'
import {useState} from 'react'
import {useSelector} from 'react-redux'

type IsValid = (button: string) => boolean

type UsePermissionButton = () => {
  isValid: IsValid
  error?: boolean
}

interface ButtonRole {
  id: boolean
  idBoton: boolean
  idRole: boolean
  nombreModulo: string
  nombreRole: string
}

const usePermissionButton: UsePermissionButton = () => {
  const {data: botonesRole, error} = useFetch('amd_getRoleBotones')
  const {user} = useSelector(({auth}: any) => auth)


  const isValid: IsValid = (button) => {
    const permission = botonesRole
      .filter(({nombreModulo}: ButtonRole) => nombreModulo === button)
      .map(({nombreRole}: ButtonRole) => nombreRole)
   
    return permission.includes(user.roleName)
  }

  return {isValid, error}
}

export default usePermissionButton
